<template>
    <div class="testPath">


        <div class="map-set">
            <div id="map-container"> </div>
        </div>
        <div class="map_input">
            <a-input id="tipinput" placeholder="兰州新区城市开放道路测试区">
                <template #suffix>
                    <a-tooltip title="搜索">
                        <img src="@/assets/images/search.png" alt="">
                    </a-tooltip>
                </template>
            </a-input>
        </div>
        <div class="area">
            <div class="area_box">
                <div>
                    区域
                    <a-select v-model:value="query.area" @change="locationChange" class="inp ml21" placeholder="请选择">
                        <a-select-option v-for="item in selectData" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </div>
                <!-- <div>
                    <a-button @click="startPoly()" type="primary">
                        面标注
                    </a-button>
                    <a-button @click="startPolyline()" class=" ml24" type="primary">
                        线标注
                    </a-button>
                    <a-button type="primary" class=" ml24"><i class="iconfont icon-piliangdaoruicon mr5"></i>
                        批量导入</a-button>
                </div> -->
            </div>
        </div>
        <!-- 新增modal 框 -->
        <div>
            <a-modal v-model:open="open" :mask="false" wrapClassName="po_mask" :width="'446px'"
                :style="{ top: '200px' }" :maskClosable="false" :maskStyle="{ background: 'transparent' }"
                :closable="false" @ok="handleModalOk">
                <template #title>
                    <div class="flex aic jcsb">
                        <div class="modal_title">{{ modalTitle }}</div>
                        <div class="out" @click="handleModalCancel">
                            <CloseOutlined />
                        </div>
                    </div>
                </template>
                <div class="modal_content">
                    <div class="area_class">
                        <div>测试区域：</div>
                        <div style="margin-left: 20px;">

                            <!-- <a-select :disabled="modalTitle == '编辑'" v-model:value="computedArea" class="area_select"
                                    style="width: 200px;margin-left: 20px;" @change="areaChange" placeholder="请输入">
                                    <a-select-option v-for="item in areaList" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select> -->

                            {{ getSelectValue(areaList, modalForm[findIndex].testZoneIdStr) }}

                        </div>
                        <!-- <div>
                            <a-button :disabled="modalTitle == '编辑'" @click="addArea" class="ml16" type="primary">
                                +新建区域
                            </a-button>
                        </div> -->
                    </div>
                    <div class="area_class">
                        <div style="margin-left: 28px;">名称：</div>
                        <div style="margin-left: 20px;">
                            <!-- <a-input v-model:value="computedName" style="width: 301px;margin-left: 20px;"
                                placeholder="请输入" /> -->
                            {{ modalForm[findIndex].name }}
                        </div>
                    </div>
                    <div class="area_class">
                        <div>测试类型：</div>
                        <div>
                            <a-select v-model:value="computedTestType" style="width: 286px;margin-left: 20px;"
                                class="area_select" placeholder="请输入">
                                <a-select-option v-for="(item, index) in typeList" :key="item.id"
                                    :value="item.dataCode + ''">{{
                        item.dataValue }}</a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <div class="area_class">
                        <div>是否预约:</div>
                        <div>
                            <a-radio-group v-model:value="computedReservation" style="margin-left: 32px;">
                                <a-radio :value="1">是</a-radio>
                                <a-radio :value="0">否</a-radio>
                            </a-radio-group>
                        </div>
                    </div>
                </div>
                <template #footer>
                    <div style="margin-top: 32px;">
                        <a-button key="back" type="primary" ghost @click="handleModalCancel">取消</a-button>
                        <a-button style="margin-bottom: 10px;" class="ml61" key="submit" type="primary"
                            @click="handleModalOk">确定</a-button>
                    </div>
                </template>
            </a-modal>
        </div>

        <!-- 新建区域 -->
        <a-modal v-model:open="areaOpen" :width="'340px'" :style="{ left: '400px', top: '200px' }" :maskClosable="false"
            :maskStyle="{ background: 'transparent' }" :closable="false" @ok="handleAreaOk">
            <template #title>
                <div class="flex aic jcsb">
                    <div class="modal_title">新建区域</div>
                    <div class="out" @click="handleAreaCancel">
                        <CloseOutlined />
                    </div>
                </div>
            </template>
            <div class="modal_content">
                <div class="area_class">
                    <div>区域名称</div>
                    <div>
                        <a-input v-model:value="areaName" style="width: 200px;margin-left: 10px;" placeholder="请输入" />
                    </div>
                </div>
            </div>
            <template #footer>
                <div style="margin-top: 32px;">
                    <a-button key="back" type="primary" ghost @click="handleAreaCancel">取消</a-button>
                    <a-button style="margin-bottom: 10px;" class="ml61" key="submit" type="primary"
                        @click="handleAreaOk">确定</a-button>
                </div>
            </template>
        </a-modal>

        <!-- 详情 -->
        <a-modal v-model:open="detailOpen" :width="'340px'" :style="{ top: '200px' }" :maskClosable="false"
            :maskStyle="{ background: 'transparent' }" :closable="false">
            <template #title>
                <div class="flex aic jcsb">
                    <div class="modal_title">详情</div>
                    <div class="out" @click="handleDetailCancel">
                        <CloseOutlined />
                    </div>
                </div>
            </template>
            <div style="margin-top: 24px;" class="modal_content">
                <div class="detail_class">
                    测试区域：{{ getSelectValue(areaList, modalForm[findIndex].testZoneIdStr) }}
                </div>
                <div class="detail_class bt_none">
                    测试类型： {{ getSingleTypeValue(appStore.SysDictVOList, dataType + 'category' +
                        modalForm[findIndex].testType)
                    }}
                </div>
                <div style="padding-left: 56px;" class="detail_class bt_none">
                    名称：{{ modalForm[findIndex].name }}
                </div>
                <div style="padding-left: 56px;" class="detail_class bt_none">
                    是否预约：{{ modalForm[findIndex].reservation === 0 ? '否' : '是' }}
                </div>
            </div>
            <template #footer>
                <div style="margin-top: 32px;">
                    <a-button key="back" type="primary" ghost @click="handleDetailCancel">取消</a-button>
                    <a-button style="margin-bottom: 10px;" class="ml61" key="submit" type="primary"
                        @click="handleDetailOk">确定</a-button>
                </div>
            </template>
        </a-modal>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, shallowRef, defineProps, watch, defineExpose, computed } from 'vue'
import AMapLoader from '@amap/amap-jsapi-loader'
import { message } from "ant-design-vue";
import { drawPolygonAndLine } from '../test/testPathComponents/drawPolygonAndLine.js' // 框和线的编辑功能
import { initializePolyAndLine } from '../test/testPathComponents/initializePolyAndLine.js'

import { getList, detail, insertOne, insertSmallOne, detailSmall, editOne } from '@/api/test/testPath.js'
import { getSingleTypeValue, getSelectValue } from '@/utils/matchDic'
import useAppStore from '@/store/modules/app';
const appStore = useAppStore()

const dataType = 'testType'

// 字典中查询 测试类型的所有值 并且渲染
const typeList = ref([])
watch(
    () => appStore.SysDictVOList,
    (val) => {
        console.log(val);
        if (val.length > 0) {
            const index = val.findIndex(item => item.dataType === dataType);
            typeList.value = val[index].children;
            console.log(typeList.value);
        }
    },
    {
        deep: true,
        immediate: true
    }
)


const map = shallowRef(null)
const mousetool = shallowRef(null);


let targetPoly = ref([]); // 保存编辑前的原始坐标点

var polyEditor = ref(null)  // 多边形编辑对象

var sourcePolygon = ref(null) // 正在编辑的原始对象

var polylineEditor = ref(null)  // 线编辑对象

// 初始化 刚进页面展示的框和线的集合  数据
const CoveringTool = shallowRef(null);

const drawType = ref('polygon')  // 绘制类型
const polygonObj = shallowRef(null)  // 框对象

const modalTitle = ref()  // modal标题
const open = ref(false);

const areaOpen = ref(false)
const areaName = ref('')

const detailOpen = ref(false)

let drawPloygonCache = ref([])// 存储已经画框的区域
const ext_id = ref(0)  //  显示 对应数据的 modal 唯一标识
const findIndex = ref(0)  // 中间建 对应modal 唯一标识

window._AMapSecurityConfig = {
    securityJsCode: 'cd0893188bd79a43d8e4539aec2e2b2a',
}

// 获取区域列表
const selectData = ref([])

let query = reactive({
    area: undefined,
});

const modalForm = ref([
])
// 保存原始数据
const copyModalObj = ref({})
const areaList = ref([
])
const copy = ref([])
const Covering = ref([])  // 覆盖物群组


let AMapObj, placeSearch, marker, geocoder;

// 通用删除infowindow
const cancelInfoWindow = (fn) => {
    const cancel = document.getElementsByClassName('icon-cancel');
    console.log(cancel);
    cancel[0] && cancel[0].addEventListener('click', fn)
}
const getDetail = id => {
    detailSmall({ id: id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            modalForm.value[findIndex.value] = res.data
        }
    })
}

const showModal = (title, e, obj) => {
    modalTitle.value = title
    open.value = true;
    console.log(obj);
    polygonObj.value = obj
    console.log(polygonObj.value);

    console.log(copy.value);

    // 点击取消 删除最后一项数据
    if (copy.value.length != 0) {
        modalForm.value = copy.value
    }
    console.log(modalForm.value);
    if (title == "编辑") {
        findIndex.value = polygonObj.value._opts.extData
        getDetail(modalForm.value[findIndex.value].id)
    } else {

        modalForm.value.push(
            {
                testZoneIdStr: '',
                name: undefined,
                testType: 'public',
                name: '',
                reservation: 0,
                coords: [],
                category: ''
            }
        )
        ext_id.value++
        modalForm.value[polygonObj.value._opts.extData].coords = polygonObj.value._opts.path
        modalForm.value[polygonObj.value._opts.extData].category = drawType.value
        console.log(ext_id.value);
        findIndex.value = ext_id.value
    }
    console.log(modalForm.value[findIndex.value]);
    // 点击取消 数据还原
    // copyModalObj.value = JSON.parse(JSON.stringify(modalForm.value[findIndex.value]))
};

const showDetailModal = (obj) => {
    detailOpen.value = true
    findIndex.value = obj._opts.extData
    getDetail(modalForm.value[findIndex.value].id)
}
var { drawing, polygonSave, polygonReset, polyLineSave, polyLineReset } = drawPolygonAndLine(CoveringTool, drawType, mousetool, map, cancelInfoWindow, drawPloygonCache, showModal, modalForm, ext_id, showDetailModal, polyEditor, Covering, sourcePolygon, findIndex, polylineEditor, targetPoly)
var { initializeData, polygonSave, polygonReset, polyLineSave, polyLineReset } = initializePolyAndLine(CoveringTool, map, showModal, showDetailModal, polyEditor, Covering, modalForm, sourcePolygon, findIndex, polylineEditor, targetPoly)

function initMap() {
    AMapLoader.load({
        key: '6588d9e5b6ae0751c799cb4c7b3e30be',  //设置您的key
        version: "2.0",
        plugins: ['AMap.ToolBar', 'AMap.Driving'],
        AMapUI: {
            version: "1.1",
            plugins: [],

        },
        Loca: {
            version: "2.0.0"
        },
    }).then((AMap) => {
        // console.log(AMap);
        AMapObj = AMap;
        map.value = new AMap.Map("map-container", {
            zoom: 16,
            // mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979',
            center: [121.209867, 31.281978],
            resizeEnable: true
        });

        // map.value.on('click', onMapClick);
        AMap.plugin(
            ['AMap.ToolBar', 'AMap.Scale', 'AMap.Geolocation', 'AMap.PlaceSearch',
                'AMap.Geocoder', 'AMap.AutoComplete', "AMap.MouseTool", "AMap.PolylineEditor", 'AMap.PolyEditor'],
            () => {
                searchMap()
                mousetool.value = new AMap.MouseTool(map.value);
            });

    }).catch(e => {
        console.log(e);
    })
}


// 搜索
const searchMap = () => {
    //输入提示
    var autoOptions = {
        input: "tipinput"
    };
    var auto = new AMap.AutoComplete(autoOptions);
    var placeSearch = new AMap.PlaceSearch({
        city: "上海",   //范围
        citylimit: true, //是否限制城市内搜索
        autoFitView: true,
        map: map.value
    });  //构造地点查询类
    auto.on("select", select);//注册监听，当选中某条记录时会触发
    function select(e) {
        console.log(e);
        placeSearch.setCity(e.poi.adcode);
        placeSearch.search(e.poi.name);  //关键字查询查询
    }
}

// 画框
const drawChart = function () {

    drawing()

}

// 开启框绘制
const startPoly = () => {

    mousetool.value.close(false);
    drawType.value = 'polygon'
    mousetool.value.polygon({
        strokeColor: "#186FF2",
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeOpacity: 0.2,
        fillColor: 'rgba(30, 142, 242, 0.40)',
        fillOpacity: 0.4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        // strokeDasharray: [30,10],
    })
    drawChart();
    console.log(drawPloygonCache.value);

}

// 开启线绘制
const startPolyline = () => {

    mousetool.value.close(false);
    drawType.value = 'polyline'
    mousetool.value.polyline({
        strokeColor: "blue",
        strokeWeight: 6,
        strokeOpacity: 0.9,
        zIndex: 50,
    })

    drawChart();
}

// 使用计算属性来处理v-model绑定的值
const computedArea = computed({
    get() {
        // 当需要判断时，可以在这里进行判断
        return modalForm.value[findIndex.value] ? modalForm.value[findIndex.value].testZoneIdStr : ''
    },
    set(newValue) {
        // 设置新值时，直接更新响应式引用
        modalForm.value[findIndex.value].testZoneIdStr = newValue;
    }
});

const computedTestType = computed({
    get() {
        // 当需要判断时，可以在这里进行判断
        return modalForm.value[findIndex.value] ? modalForm.value[findIndex.value].testType : ''
    },
    set(newValue) {
        // 设置新值时，直接更新响应式引用
        modalForm.value[findIndex.value].testType = newValue;
    }
});

const computedName = computed({
    get() {
        // 当需要判断时，可以在这里进行判断
        return modalForm.value[findIndex.value] ? modalForm.value[findIndex.value].name : ''
    },
    set(newValue) {
        // 设置新值时，直接更新响应式引用
        modalForm.value[findIndex.value].name = newValue;
    }
});

const computedReservation = computed({
    get() {
        // 当需要判断时，可以在这里进行判断
        return modalForm.value[findIndex.value] ? modalForm.value[findIndex.value].reservation : 0
    },
    set(newValue) {
        // 设置新值时，直接更新响应式引用
        modalForm.value[findIndex.value].reservation = newValue;
    }
});

// 获取区域列表
const getAreaList = () => {
    getList().then(res => {
        console.log(res);
        if (res.code === 200) {
            selectData.value = res.data
            query.area = res.data[0].id
            areaList.value = res.data
            getDetailData(query.area)
        }

    })
}

// 获取区域下全部片区
const getDetailData = (id) => {
    detail({ id: id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            setTimeout(() => {
                res.data.map((i) => {
                    i.locationInfo = JSON.parse(i.locationInfo);
                    // i.coords = i.coords.map(item => {
                    //     return item.map(Number)
                    // })
                })
                modalForm.value = res.data
                console.log(modalForm.value);
                let data = JSON.parse(JSON.stringify(modalForm.value))
                ext_id.value = modalForm.value.length - 1
                console.log(ext_id.value);
                if (map.value) {
                    clearMap();
                    set_map();
                }
            }, 1200)
        }
    })
}

const set_map = () => {
    console.log(map.value, 'map.value');
    if (map.value) {
        map.value && addCovering()
    } else {
        setTimeout(() => {
            map.value && addCovering()
        }, 1200);
    }
}


const addCovering = () => {
    console.log(modalForm.value);
    Covering.value && map.value.remove(Covering.value) // 清除所有的覆盖物
    Covering.value = []
    // 添加覆盖物
    modalForm.value.forEach((item, index) => {
        Covering.value.push(addDrawaddCovering(item, index))
    })

    map.value.add(Covering.value) // 动态添加数据
    map.value.setFitView();//让所有点都在可视区域内
}

const addDrawaddCovering = (item, index) => {
    let record = JSON.parse(JSON.stringify(item))

    // let Point = []
    // Point.push(
    //     [item.startLocationVo.lng, item.startLocationVo.lat],
    //     [item.endLocationVo.lng, item.endLocationVo.lat],
    // )

    // var Covering
    if (record.locationInfo.type == 'polygon') {
        console.log(record.locationInfo.coordinates);
        // 画面
        CoveringTool.value = new AMap.Polygon({
            path: record.locationInfo.coordinates,
            zIndex: 50,
            bubble: true,
            strokeColor: "#F23218",
            strokeOpacity: 1,
            strokeWeight: 2,
            strokeOpacity: 0.7,
            fillColor: '#F2AA1E',
            fillOpacity: 0.4,
            // 线样式还支持 'dashed'
            strokeStyle: "solid",
            // strokeStyle是dashed时有效
            // strokeDasharray: [30,10],
        })
    } else {
        // 画线
        // CoveringTool.value = new AMap.Polyline({
        //     path: record.locationInfo.coordinates,
        //     strokeColor: "blue",
        //     strokeWeight: 6,
        //     strokeOpacity: 0.9,
        //     zIndex: 50,
        //     bubble: true,
        // })

        // 画圆
        CoveringTool.value = new AMap.Circle({
            center: record.locationInfo.coordinates,
            radius: record.locationInfo.radius, //半径
            borderWeight: 3,
            strokeColor: "#F23218",
            strokeOpacity: 1,
            strokeWeight: 2,
            strokeOpacity: 0.7,
            fillOpacity: 0.4,
            strokeStyle: 'solid',
            strokeDasharray: [10, 10],
            // 线样式还支持 'dashed'
            fillColor: '#F2AA1E',
            zIndex: 50,
        })

    }
    // 设置绘制覆盖物的属性
    CoveringTool.value.setExtData(index);
    // console.log(CoveringTool.value);
    initializeData() // 数据刚开始进来 初始化
    return CoveringTool.value


}

// 新增区域
const addArea = () => {
    areaOpen.value = true
}

// 新增区域 接口
const postInsertOne = async (data) => {
    let res = await insertOne(data)
    if (res.code === 200) {
        let info = await getList()
        if (info.code === 200) {
            selectData.value = info.data
            areaList.value = info.data
        }
        message.success('新增区域成功')

    }

}

const handleAreaOk = () => {
    if (areaName.value === '') {
        message.error('请输入区域名称')
    } else {
        if (areaList.value.length !== 0) {
            let found = areaList.value.find(element => element.name === areaName.value);
            if (found) {
                message.error('测试区域已存在')
            } else {
                postInsertOne({ name: areaName.value })
                areaOpen.value = false
                areaName.value = ''
            }
        } else {
            postInsertOne({ name: areaName.value })
            areaOpen.value = false
            areaName.value = ''
        }

    }
}

const handleAreaCancel = () => {
    areaName.value = ''
    areaOpen.value = false
}

// 新增 and 编辑
const handleModalOk = e => {
    // console.log(e);
    let data = JSON.parse(JSON.stringify(modalForm.value))
    if (modalTitle.value === '新增') {
        console.log(data[ext_id.value].name);
        if (!data[ext_id.value].testZoneIdStr) {
            message.error('请输入测试区域')
        } else if (data[ext_id.value].name === '') {
            message.error('请输入名称')
        } else {
            // 新增区域片区
            insertSmallOne(data[findIndex.value]).then(res => {
                if (res.code === 200) {
                    getDetailData(data[findIndex.value].testZoneIdStr)
                    query.area = data[findIndex.value].testZoneIdStr
                    message.success('新增区域片区成功')
                    console.log(data);
                    open.value = false;
                }
            })
            modalForm.value = data
        }

    } else {
        console.log(data[findIndex.value].name);
        if (!data[findIndex.value].testZoneIdStr) {
            message.error('请输入测试区域')
        } else if (data[findIndex.value].name === '') {
            message.error('请输入名称')
        } else {
            console.log(sourcePolygon.value);

            if (data[findIndex.value].category === "polygon") {
                polygonSave()
            } else {
                polyLineSave()
            }
            editOne(data[findIndex.value]).then(res => {
                if (res.code === 200) {
                    getDetailData(data[findIndex.value].testZoneIdStr)
                    message.success('修改区域片区成功')
                    console.log(data);
                    open.value = false;
                }
            })
            modalForm.value = data
        }

    }
    console.log(data);

};
const handleModalCancel = () => {
    // 点击取消 数据还原
    // modalForm.value[findIndex.value] = copyModalObj.value
    // areaList.value = JSON.parse(JSON.stringify(modalForm.value));
    if (modalTitle.value === '新增') {
        open.value = false;
        map.value.remove(polygonObj.value);
        ext_id.value--
        copy.value = JSON.parse(JSON.stringify(modalForm.value))
        copy.value.splice(-1, 1)
    } else {
        console.log(modalForm.value[findIndex.value].category);
        // 点击取消 重置数据
        if (modalForm.value[findIndex.value].category === "polygon") {
            polygonReset()
        } else {
            polyLineReset()
        }
        open.value = false;
    }

};


// 详情
const handleDetailCancel = () => {
    detailOpen.value = false
}
const handleDetailOk = () => {
    detailOpen.value = false
}

const areaChange = (e) => {
    console.log(e)
    console.log(areaList.value)
    console.log(modalForm.value[findIndex.value].testZoneIdStr);
}

// 精准定位
const locationChange = (value) => {
    console.log(value);
    query.area = value
    getDetailData(query.area)

    // let newData = JSON.parse(JSON.stringify(modalForm.value))
    // let data = newData.find(item => item.name == value)
    // // 计算 绘制区域 中心点
    // let center = [0, 0];
    // data.coords.map(item => {
    //     center[0] += item[0];
    //     center[1] += item[1];
    // });
    // console.log(center);
    // map.value.setCenter([center[0] / data.coords.length, center[1] / data.coords.length], true);
    // if (map.value.getZoom() < 17) {
    //     map.value.setZoom(17)
    // }
}

//清除地图;
const clearMap = () => {
    if (window.loca) {
        //清空所有图层，包括图层的光源
        window.loca.clear();
    }
    map.value && map.value.clearMap();

}
//销毁地图
const destroyMap = () => {
    map.value && map.value.destroy();
    console.info("地图已销毁");
}

onMounted(() => {
    clearMap()
    // drawMap()
    initMap()
    getAreaList()
    // getData()

})


onBeforeMount(() => {
    // convertLightList()
    destroyMap()

})
</script>
<style lang="less" scoped>
@import url(./testPath.less);
</style>
